export const TIMEREPORTLIST_SEARCH = 'TIMEREPORTLIST_SEARCH';
export const TIMEREPORTLIST_PAGE = 'TIMEREPORTLIST_PAGE';
export const TIMEREPORTLIST_STARTDATE = 'TIMEREPORTLIST_STARTDATE';
export const TIMEREPORTLIST_ENDDATE = 'TIMEREPORTLIST_ENDDATE';
export const TIMEREPORTLIST_ACTIVITYLABELID = 'TIMEREPORTLIST_ACTIVITYLABELID';
